module.exports = __webpack_public_path__ + "img/error.83798e08.gif";